import { MapIcon, SearchIcon } from '@instacart/ids-core'
import { useDebouncedState } from '@retailer-platform/shared-components'
import React, { type FunctionComponent, useEffect } from 'react'
import { SearchInput } from '@retailer-platform/shared-components/src/tds'
type SearchTextBarProps = {
  css?: React.CSSProperties
  placeholder?: string
  onChange?: (str: string) => void
  value?: string
}

export const SearchTextBar: FunctionComponent<React.PropsWithChildren<SearchTextBarProps>> = ({
  placeholder,
  onChange,
  value,
  css,
  ...rest
}) => {
  const [term, debouncedTerm, setTerm, isChangePending] = useDebouncedState(value, 500)

  // Propagate value once the debounced value changes
  useEffect(() => {
    if (debouncedTerm == null || !onChange) return
    onChange(debouncedTerm)
  }, [debouncedTerm, onChange])

  return (
    <SearchInput
      maxWidthPx={228.5}
      placeholder={placeholder}
      data-testid="search-text-input"
      id="search-text-input"
      value={term}
      onChange={evt => {
        setTerm(evt.target.value)
      }}
      style={css}
      isLoading={isChangePending}
      {...rest}
    />
  )
}
